const translations = {
  'header': {
    'main': 'Главная',
    'vozm': 'Возможности',
    'products': 'Продукты',
    'docs': 'Документы',
    'request': 'Отправить запрос',
  },
  'mainPage': {
    'title': 'Банк в одном устройстве!',
    'desc': 'Контролируй свои финансы легко и удобно!',
    'request': 'Отправить запрос',
  },
  'vozm': {
    'mainTitle': 'Возможности Ориён Бизнеса',
    'title1': 'Простое подписание платежей с SМS- кодом',
    'title3': 'Работает на любом устройстве',
  },
  'products': {
    'mainTitle': 'Продукты для вашего бизнеса',
    'title2': 'Торговый эквайринг',
    'title3': 'Зарплатный проект',
    'title4': 'Расчётно-кассовое обслуживание',
  },
  'documents': {
    'mainTitle': 'Документы',
    'title1': 'Тарифы',
  },
  'footer': {
    'forClients': {
      'title': 'Клиентам',
    },
    'aboutBank': {
      'title': 'О банке',
    },
    'products': {
      'title': 'Продукты',
    },
    'contacts': {
      'title': 'Контакты',
      'address': 'г. Душанбе, Рудаки, 95/1',
    },
  },
  'RECEIVED': 'Принят',
  'IN_PROGRESS': 'В обработке',
  'IN_VERIFICATION': 'СМС подтвеждение',
  'IN_CONFIRMATION': 'Ждет подтверждения',
  'READY': 'Готов',
  'SUCCESS': 'Успешно',
  'FAILED': 'Не успешно',
  'DECLINED': 'Отклонен',
  'INVALID_FILE': 'Не валидный',
  'INVALID': 'Не валидный',
  'IN_APPROVAL': 'На авторизации',
  'TO_APPROVE': 'Ждет авторизации',
  'APPROVED': 'Одобрен',
  'PARTIAL_SUCCESS': 'Частично проведен',
  'POSTPONED': 'Отложен',
  'IN_BANK_REVIEW': 'На расмотрении',
  'IN_REVIEW': ' На расмотрении',
  'BANK_APPROVED': 'Одобрен',
  'CANCELED': 'Отменен',
  'BANK_DECLINED': 'Отклонен банком',
  'REVERSED': 'Возвращен',
  'IN_VALIDATION': 'Проверяется',
  'READY_TO_PROCEED': 'Готов к проведению',
  'Language': 'Русский',
  'Transactions': 'Транзакции',
  'Accounts': 'Счета',
  'Filter': 'Фильтр',
  'Status': 'Статус',
  'Find': 'Поиск',
  'ID': 'ID',
  'Name': 'Название',
  'Phone number': 'Номер телефона',
  'Intrabank': 'Внутрибанковский',
  'Salaries': 'Зарплаты',
  'Interbank': 'Межбанковский',
  'Interbank payment': 'Межбанковский платеж',
  'SWIFT': 'СВИФТ',
  'Ruble': 'Рублевый',
  'Account': 'Счет',
  'Search': 'Поиск',
  'All': 'Все',
  'Sign in': 'Войти в систему',
  'Signing in': 'На подписании',
  'Processing': 'В обработке',
  'Not successful': 'Не успешные',
  'Successful': 'Успешные',
  'Date': 'Дата',
  'Sender': 'Отправитель',
  'Recipient': 'Получатель',
  'Sender account': 'Счет отправителя',
  'Recipient account': 'Счет получателя',
  'Transaction type': 'Тип транзакции',
  'Amount': 'Сумма',
  'Login': 'Логин',
  'Password': 'Пароль',
  'Sign up': 'Зарегистрироваться',
  'Exchange Rates': 'Курс валют',
  'NBT': 'НБТ',
  'Currency': 'Валюта',
  'Purchase': 'Покупка',
  'Sale': 'Продажа',
  'USD': 'USD',
  'EUR': 'EUR',
  'RUB': 'RUB',
  'All accounts': 'Все счета',
  'TJS': 'TJS',
  'Last operations': 'Последние операции',
  'Between own accounts': 'Между своими счетами',
  'Intrabank payment': 'Внутрибанковский платеж',
  'MyAccounts': 'Мои счета',
  'Active': 'Активный ',
  'Not active': 'Не активный',
  'Update': 'Обновить',
  'Updated': 'Обновлен',
  'Russian': 'Руский',
  'English': 'Англиский',
  'Tajik': 'Таджикский',
  'Bank accounts': 'Банковские счета',
  'Visa Business': 'Visa Business',
  'Payment Information': 'Информация о платеже',
  'Account Information': 'Информация о счете',
  'File information': 'Информация о файле',
  'Account name': 'Название счета',
  'Balance': 'Баланс',
  'Account type': 'Тип счета',
  'Address': 'Адрес',
  'TIN': 'ИНН',
  'Date of opening': 'Дата открытия',
  'Requisites': 'Реквизиты',
  'Download': 'Скачать',
  'Upload': 'Загрузить',
  'Upload file': 'Загрузка файла',
  'Description': 'Описание',
  'Show filters': 'Показать фильтры',
  'No transaction': 'Транзакций нет',
  'TxID': 'ID транзакции',
  'Commission': 'Комиссия',
  'Commission amount': 'Сумма комиссии',
  'Commission km': 'Комиссия Корти милли',
  'Commission visa': 'Комиссия Visa',
  'Date of creation': 'Дата создания',
  'Retry payment': 'Повторить платеж',
  'Download PDF': 'Скачать PDF',
  'Authorizers': 'Авторизаторы',
  'Reject': 'Отклонить',
  'Confirm': 'Подтвердить',
  'Payment information': 'Сведения о платеже',
  'Bank information': 'Сведения о банке',
  'From account': 'Со счета',
  'To account': 'На счет',
  'Transfer amount': 'Сумма перевода',
  'Narrative': 'Назначение',
  'Existing template': 'Существующий шаблон',
  'Sender information': 'Сведения о отправителе',
  'Recipient information': 'Сведения о получателе ',
  'Account number': 'Номер счета',
  'Confirm account number': 'Подтвердить номер счета',
  'Payment details': 'Подробности оплаты',
  'Other details': 'Другие детали',
  'Document type': 'Тип документа',
  'Document number': 'Номер документа',
  'Document date': 'Дата документа',
  'Save template': 'Сохранить шаблон',
  'Country': 'Страна',
  'City': 'Город',
  'Enter amount': 'Введите сумму',
  'Document': 'Документ',
  'Enter document number': 'Введите номер документа',
  'Initiator': 'Инициатор',
  'Number of transactions': 'Количество транзакций',
  'Import': 'Импорт',
  'Rejected': 'Отклонен',
  'Importing payments from a file': 'Импорт платежей из файла',
  'Download document': 'Загрузить документ',
  'Salary project': 'Зарплатный проект',
  'Select account': 'Выбрать счет',
  'Select date': 'Выбрать дату',
  'Order an statement': 'Заказать выписку',
  'View orders': 'Просмотреть заказы',
  'Orders': 'Заказы',
  'Ordering a statement': 'Заказ выписки',
  'Enter the title': 'Введите название',
  'Order': 'Заказать',
  'Ready': 'Готов',
  'In progress': 'Обрабатывается',
  'Failed': 'Неуспешно',
  'Period': 'Период',
  'Tariffs': 'Тарифы',
  'Transfer between own accounts': 'Перевод между своими счетами',
  'Show all currencies': 'Показать все валюты',
  'Rate': 'Курс',
  'Currency сode': 'Код валюты',
  'Unit': 'Единица измерения',
  'Currency name': 'Наименавание валюты',
  'No.': '№',
  'Change Password': 'Смена пароля',
  'Log out': 'Выйти',
  'Profile': 'Профиль',
  'Enter a new password': 'Введите новый пароль',
  'Enter old password': 'Введите старый пароль',
  'Change': 'Поменять',
  'Contacts': 'Контакты',
  'oriyon-business@oriyonbonk.tj': 'oriyon-business@oriyonbonk.tj',
  'Call center 2222': 'Контактный центр 2222',
  'Loans': 'Кредиты',
  'Deposits': 'Вклады',
  'OtpCode': 'Код подтверждения',
  'ResendTime': 'Повторная отправка будет доступна через',
  'Second': 'секунд',
  'ResendCode': 'Отправить код ещё раз',
  'Save': 'Сохранить',
  'All operations': 'Все операции',
  'Operation': 'Операция',
  'No Transactions': 'Транзакций нет',
  'Payments': 'Платежи',
  'More': 'Ещё',
  'Notifications': 'Уведомления',
  'No notifications': 'Нет уведомлений',
  'New': 'новые',
  'CurrienciesToSomoni': 'Официальные курсы валют к сомони (НБТ):',
  'Hide all currencies': 'Скрыть все валюты',
  'ToSign': 'Подпишите',
  'Rejecteds': 'Отклоненные',
  'Enter Recipient Account': 'Введите счет получателя',
  'Confirm payment': 'Подтверждение платежа',
  'Payment type': 'Тип операции',
  'Enter Recipient': 'Введите получателя',
  'Enter TIN': 'Введите ИНН',
  'Enter template name': 'Введите название шаблона',
  'Recipient TIN': 'ИНН получателя',
  'Show balance': 'Показать баланс',
  'Hide balance': 'Скрыть баланс',
  'Hide filters': 'Скрыть фильтр',
  'Swift': 'СВИФТ',
  'Bank name': 'Название банка',
  'Filters': 'Фильтры',
  'Show': 'Показать',
  'Select template': 'Выбрать шаблон',
  'One Dollar': '1 Доллар',
  'One Ruble': '1 Рубль',
  'One Euro': '1 Евро',
  'Orienbank Address': 'г.Душанбе, Рудаки, 95/1',
  'Enter City': 'Введите город',
  'Enter Country': 'Введите страну',
  'Enter Address': 'Введите адрес',
  'Enter Account': 'Введите счет',
  'Enter swift code': 'Введите свифт код',
  'Enter bank name': 'Введите название банка',
  'Enter doc number': 'Введите номер документа',
  'Enter SMS code': 'Введите СМС код',
  'Find swift code': 'Найти свифт код',
  'Find bic code': 'Найти БИК код',
  'Required': 'Обязательное поле',
  'Enter symbol only': 'Ввод только символов',
  'Amount must be more 1': 'Сумма должна быть больше 1',
  'Wrong amount': 'Неправильная сумма',
  'Wrong type': 'Неправильный тип',
  'Latin Only': 'Ввод только латиницы',
  'Account does not match': 'Введенный вами счет не совпадает!',
  'Account must contain no more than 20 digits': 'Счет должен содержать не больше 20 цифр',
  'Account must contain no more than 21 digits': 'Счет должен содержать не больше 21 цифр',
  'Account must contain no more than 35 digits': 'Счет должен содержать не больше 35 цифр',
  'Account must contain at least 20 digits': 'Счет должен содержать не меньше 20 цифр',
  'Account must contain at least 6 digits': 'Счет должен содержать не меньше 6 цифр',
  'Account must contain at least 7 digits': 'Счет должен содержать не меньше 7 цифр',
  'Enter number only': 'Ввод только цифр',
  'ConfirmSmsFromPhone': 'Для подтверждения транзакции на номер вашего телефона отправлен СМС код',
  'No accounts': 'Нет счетов',
  'Account does not found': 'Счет не найден!',
  'Must be 9 numbers': 'Должно быть 9 цифр',
  'Field must contain at least 8 digits': 'Поле должно содержать не менее 8 символов!',
  'For registration':
    'Для регистрации в системе Интернет-Банкинга, Вам необходимо обратиться в Головной офис Ориёнбонка, по адресу',
  'For any questions': 'По всем вопросам обращайтесь в наш Контактный центр мы с удовольствием поможем Вам',
  'Code': 'Код',
  'Sent code to phone for sequirity': 'Для защиты Вашего профиля мы отправим код подтверждения на Ваш номер телефона',
  'Sent code to email for sequirity': 'Для защиты Вашего профиля мы отправим код подтверждения на Вашу почту',
  'Google auth otp description':
    'У вас включена аутентификация через Google Authenticator. Введите 6-значный код из приложения.',
  'Change your password': 'Поменяйте свой пароль',
  'Password does not match': 'Введенный вами пароль не совпадает!',
  'Confirm password': 'Подтвердите пароль',
  'Change and remind password': 'Поменяйте и запомните свой пароль',
  'International': 'Валютный перевод',
  'International tjs': 'Свифт в сомони',
  'File date': 'Дата файла',
  'Total amount': 'Общая сумма',
  'Debit': 'Дебет',
  'Credit': 'Кредит',
  'Own accounts payments': 'Транзакций между своими счетами',
  'Intrabank payments': 'Внутрибанковские платежи',
  'Interbank payments': 'Межбанковские платежи',
  'Successful count': 'Успешных',
  'Not successful count': 'Неуспешных',
  'Download file': 'Скачать файл',
  'Company information': 'Информация о компании',
  'Error': 'Ошибка',
  'Transaction list': 'Список транзакций',
  'Branch': 'Филиал',
  'Card accounts': 'Карточные счета',
  'Approved': 'Одобрил',
  'From amount': 'Сумма от',
  'To amount': 'Сумма до',
  'Start date': 'Дата начала',
  'End date': 'Дата конца',
  'Start period': 'Начало периода',
  'End period': 'Конец периода',
  'No data': 'Нет данных',
  'Enter document type': 'Введите тип документа',
  'In confirmation': 'Ждет подтверждения',
  'In verification': 'На авторизации',
  'Partial success': 'Частично проведеные',
  'Download salary file template': 'Скачать шаблон зарплатного файла',
  'Upload document': 'Загрузить документ',
  'The file format must be xlsx, xls': 'Формат файла должен быть xlsx, xls',
  'The file format must be txt': 'Формат файла должен быть txt',
  'The file size should not exceed 2MB': 'Размер файла не должен превышать 2мб',
  'Wrong file format': 'Неверный формат файла',
  'FIO': 'ФИО',
  'Company name': 'Название компании',
  'International payment': 'Международный платеж',
  'Transaction date': 'Дата транзакции',
  'Back': 'Вернуться',
  'Repeat': 'Повторить',
  'Urgent': 'Срочный',
  'Edit account name': 'Редактировать название счета',
  'Maximum number of characters: 70': 'Максимальное количество символов: 70',
  'Confirm new password': 'Подтвердите новый пароль',
  'Exit': 'Выход',
  'Pick': 'Выбрать',
  'Enter number or letter only': 'Ввод только букв или цифр',
  'Sure to confirm?': 'Вы уверены что хотите подтвердить?',
  'Sure to decline?': 'Вы уверены что хотите отклонить?',
  'Cancel': 'Отмена',
  'Make a payment': 'Провести платеж',
  'Enter': 'Войти',
  'Insufficient funds in the account': 'Недостаточно средств на счете',
  'Templates': 'Шаблоны',
  'Internal': 'Внутрибанковский',
  'Delete': 'Удалить',
  'BIC': 'БИК',
  'No Templates': 'Шаблонов нет',
  'Statement': 'Выписка',
  'Exchange': 'Конвертация',
  'Credit amount': 'Сумма к снятию',
  'Debit amount': 'Сумма к пополнению',
  'Beneficiary Bank': 'Банк получателя',
  'Print': 'Распечатать',
  'View all': 'Просмотреть все',
  'otpType': 'Выберите способ получения кода подтверждения',
  'withSMS': 'Через СМС',
  'withEmail': 'На почту',
  'Email': 'Почта',
  'Recipient country': 'Страна получателя',
  'Recipient city': 'Город получателя',
  'Recipient address': 'Адрес получателя',
  'Recipient bank address': 'Адрес банка получателя',
  'Recipient bank name': 'Название банка получателя',
  'Recipient country name': 'Страна банка получателя',
  'Recipient bank swift': 'СВИФТ код банка получателя',
  'onlyTwoMonths': 'Не более двух месяцев',
  'Oriyon': 'Ориён',
  'Business': 'Бизнес',
  'Account Balances': 'Остатки счетов',
  'Account Balances in somoni': 'Остатки счетов в сомони',
  'Account Balances in dollars': 'Остатки счетов в долларах',
  'Account Balances in euro': 'Остатки счетов в евро',
  'Account Balances in ruble': 'Остатки счетов в рублях',
  'Account Balances in riyal': 'Остатки счетов в риялах',
  'Account Balances in yuan': 'Остатки счетов в юанях',
  'Select format': 'Выберите формат',
  'Format': 'Формат',
  'Enter bic code': 'Выберите БИК код',
  'Ruble transfer': 'Рублевый перевод',
  'PrepaymentForProduct': 'Предоплата за товар',
  'PaymentForProduct': 'Оплата за товар',
  'PrepaymentForService': 'Предоплата за услуги',
  'PaymentForService': 'Оплата за услуги',
  'Others': 'Прочие',
  'Select narrative': 'Выберите назначение',
  'EditionalInfo': 'Дополнительная информация',
  'Enter KPP': 'Введите КПП',
  'Correspondent account': 'Счет корреспондента',
  'All currencies': 'Все валюты',
  '4 somoni': '4 сомони',
  'Download extract': 'Скачать выписку',
  'Closed': 'Закрыт',
  'Loan amount': 'Сумма кредита',
  'Loan start date': 'Дата выдачи',
  'Loan end date': 'Дата окончания',
  'Loan balance': 'Остаток кредита',
  'Loan Information': 'Информация о кредите',
  'Loan type': 'Тип кредита',
  'Download payment schedule': 'Скачать график платежей',
  'Accredits': 'Аккредитив',
  'Overdraft': 'Овердрафт',
  'No loans': 'Кредитов нет',
  'Next payment date': 'Дата следующего погашения',
  'Amount due': 'Сумма погашения',
  'Deposit owner': 'Владелец депозита',
  'Deposit Information': 'Информация о депозите',
  'Month': 'Месяц',
  'Percent': 'Процент',
  'Loan requests': 'Заявки на кредит',
  'Submit request': 'Оставить заявку',
  'Loan term': 'Срок кредита',
  'Purpose': 'Цель кредита',
  'No requests': 'Заявок нет',
  'Request create title': 'Онлайн-подача заявки на финансирование',
  'Request preview title': 'Предпросмотр заявления перед отправкой',
  'Deal parameters': 'Параметры сделки',
  'Applicant data': 'Данные заявителя',
  'Loan product type': 'Тип кредитного продукта',
  'Financing amount': 'Сумма финансирования',
  'Desired term in months': 'Желаемый срок (в месяцах)',
  'Financing purpose': 'Цель финансирования',
  'Director full name': 'ФИО Генерального директора',
  'Generate preview': 'Сформировать для предпросмотра',
  'Back to edit': 'Назад (Редактировать)',
  'Send request to bank': 'Отправить заявку в банк',
  'Request submitted': 'Заявка успешно отправлена!',
  'Request submitted desc': 'Банк рассмотрит вашу заявку и свяжется с вами по указанным контактам.',
  'Back to requests': 'Вернуться к заявкам',
  'Product type Loan': 'Кредит',
  'Additional documents': 'Дополнительные приложения',
  'Recommended documents list': 'Рекомендуемый перечень файлов',
  'up to': 'до',
  'Select file': 'Выбрать файл',
  'Attached documents': 'Прикрепленные к заявлению документы',
  'No documents attached': 'Дополнительные приложения не загружались (только заявление LOI)',
  'File is too large': 'Размер файла слишком велик',
  'MB': 'МБ',
  'Document bank form': 'Заявка по форме банка',
  'Document balance': 'Баланс предприятия',
  'Document passports': 'Паспорта руководства',
  'Document contracts': 'Контракты',
  'Document feasibility study': 'Технико-экономическое обоснование (ТЭО)',
  'No deposits': 'Вкладов нет',
  'Counterparties': 'Контрагенты',
  'Add': 'Добавить',
  'New counterparty': 'Новый контрагент',
  'Foreigs': 'Иностранные контрагенты',
  'Residents': 'Резиденты',
  'Resident': 'Резидент',
  'Personal': 'Персональный',
  'Public': 'Публичный',
  'templateType': 'Тип шаблона',
  'downloadTemplates': 'Скачать шаблоны',
  'Yes': 'Да',
  'No': 'Нет',
  'today': 'За сегодня',
  'for3days': 'За 3 дня',
  'forWeek': 'За неделю',
  'forMonth': 'За месяц',
  'Select counterparty': 'Выбрать контрагента',
  'Pick counterparty': 'Выбор контрагента',
  'Download list': 'Скачать список',
  'Operation is not permitted': 'Операция не разрешается',
  'Own accounts payment shortname': 'Свои счета',
  'Electric': 'Электроэнергия',
  'Personal account number': 'Номер лицевого счёта',
  'Select region': 'Выберите регион',
  'Electricity payment': 'Оплата электроэнергии',
  'Indication': 'Показание',
  'Select language': 'Выберите язык',
  'Clean': 'Очистить',
  'Download selected': 'Скачать выбранные',
  'Custom payments': 'Таможенные платежи',
  'Payer': 'Плательщик',
  'Account owner': 'Владелец',
  'TinNotFoundInAsycuda': 'ИНН не найден в системе АСИКУДА',
  'Disposal': 'Утилизация',
  'Disposal payment': 'Оплата утилизации',
  'Custom payment attention': 'Таможенные платежи проводятся исключительно через вкладку "Таможенные платежи"',
  'Leave a review': 'Оставить отзыв',
  'Username': 'Имя пользователя',
  'Support service': 'Служба поддержки',
  'Write to chat': 'Написать в чат',
  'Online support': 'Онлайн-поддержка',
  'Frequently asked questions': 'Часто задаваемые вопросы',
  'Your feedback helps us': 'Ваш отзыв помогает нам',
  'Review': 'Отзыв',
  'Suggestion': 'Предложение',
  'Send': 'Отправить',
  'Thank you for your feedback': 'Благодарим за отправленный отзыв',
  'Message': 'Сообщение',
  'Type of request': 'Вид обращения',
  'Security': 'Безопасность',
  'Quick navigation': 'Быстрый переход',
  '2FA On': 'включён',
  '2FA Off': 'выключен',
  'Phone label': 'Телефон',
  'Contact info': 'Контактные данные',
  'Contact info desc': 'Телефон и почта для уведомлений и подтверждений',
  'Change contact info': 'Изменение контактных данных',
  'Enter phone number': 'Введите номер телефона',
  'Enter email': 'Введите адрес почты',
  'Invalid email': 'Некорректный адрес почты',
  'ConfirmContactInfoOtp': 'Для подтверждения изменения контактных данных вам отправлен код подтверждения',
  'Name label': 'Имя',
  'Payments nav desc': 'Создать и отправить платёж',
  'Statement nav desc': 'Выписка по счёту',
  'Accounts nav desc': 'Все банковские счета',
  'Transactions nav label': 'История операций',
  'Transactions nav desc': 'Все транзакции',
  'Templates nav desc': 'Сохранённые шаблоны',
  'Enabled': 'Включён',
  'Disabled': 'Выключен',
  'Connect Google Auth': 'Подключить Google Authenticator',
  'Scan QR code': 'Отсканируйте QR-код в приложении Google Authenticator',
  'After scan click enable': 'После сканирования нажмите «Включить»',
  'Enable': 'Включить',
  'Disable': 'Отключить',
  'Disable 2FA title': 'Отключить двухфакторную аутентификацию',
  'Disable 2FA confirm':
    'Вы уверены, что хотите отключить двухфакторную аутентификацию? Это снизит защиту вашего аккаунта.',
  'swiftAttention': {
    'title': 'Важная информация',
    'dearClients': 'Уважаемые клиенты',
    'payAttention':
      'В целях предотвращения ошибок и возможных последствий, связанных с их возникновением, убедительно просим Вас проявлять максимальную внимательность при заполнении реквизитов платежа —',
    'narrative': 'особенно поле «Назначение платежа»',
    'file': 'Также просим вас не забывать прикреплять подтверждающие документы при отправке платежей.',
  },
  'Footer': {
    'address':
      'Республика Таджикистан, г. Душанбе, проспект Рудаки 95/1 К/С: 20402972413691, ИНН: 020003038, БИК: 350101369',
    'emails': 'Эл. адрес',
    'tj': 'Для звонков по Таджикистану',
    'nbt': 'Горячая линия Национального Банка Таджикистана',
    'workTime': 'Рабочее время',
    'workDays': 'Рабочие дни: с понедельника по пятницу с 08:00 до 17:00',
    'sunday': 'Воскресенье: выходной',
    'orb': 'ОАО "Ориёнбонк"',
    'license': 'Лицензия НБТ №0000004 от 30 января 2014г',
    'supportNumber': 'Служба поддержки Ориенбизнес',
    'dayOf': 'Суббота и Воскресенье - выходные',
  },
  'security': {
    'title': 'Безопасность вашего бизнеса: как не дать мошенникам украсть деньги и подставить компанию',
    'sectionPrefix': 'Раздел',
    'section1Title': 'Проверка подлинности запросов',
    'section1Subtitle': 'Ваши основные правила безопасности при общении.',
    'section2Title': 'Комплаенс-безопасность бизнеса',
    'section2Subtitle': 'Рекомендации по защите компании от блокировок и юридических рисков.',
    'labelAction': 'Действие',
    'labelConsequence': 'Последствие',
    'labelRule': 'Правило',
    'labelRisk': 'Риск',
    'labelCheck': 'Точка контроля',
    's1i1Title': '«Срочное поручение руководителя»',
    's1i1Text':
      'Если вы получили запрос в мессенджере или по почте от имени директора с просьбой срочно перевести деньги по новым реквизитам — это повод для тревоги. Мошенники могут имитировать стиль общения и даже голос.',
    's1i1Action': 'Обязательно перезвоните руководителю по обычному телефону и подтвердите поручение лично.',
    's1i2Title': '«Лже-техподдержка»',
    's1i2Text':
      'Звонки от «сотрудников банка» с просьбой установить AnyDesk, RustDesk или TeamViewer для «настройки системы».',
    's1i2Action': 'Немедленно положите трубку. Банк никогда не требует установки программ удалённого доступа.',
    's1i3Title': 'Подмена номера (Спуфинг)',
    's1i3Text':
      'Мошенники используют технологии, чтобы на экране вашего мобильного телефона высветился официальный номер Банка.',
    's1i3Action':
      'Если у вас запрашивают коды из СМС или пароли — сбросьте вызов и сами наберите номер банка с официального сайта.',
    's2i1Title': 'Риск «Транзитёрства» (ПОД/ФТ)',
    's2i1Text': 'Вам поступил «ошибочный» платёж, и вас просят вернуть его, но на другие реквизиты или наличными.',
    's2i1Consequence': 'Вы становитесь звеном в цепочке отмывания денег, что ведёт к блокировке всех счетов компании.',
    's2i1Rule': 'Возврат только по официальному письму и только на тот счёт, с которого пришли деньги.',
    's2i2Title': 'Санкционные ловушки',
    's2i2Text': 'Контрагент предлагает сложные схемы оплаты через цепочку посредников или на счета третьих лиц.',
    's2i2Risk': 'Нарушение международных санкций, что может лишить банк и вашу компанию доступа к валютным операциям.',
    's2i3Title': 'Фиктивные услуги',
    's2i3Text': 'Оплата маркетинга, консалтинга или IT-услуг компаниям без штата, офиса и истории.',
    's2i3Check': 'Банк проверяет реальность деятельности. Работа с «пустышками» — признак вывода средств.',
    'alertTitle': 'При подозрении на мошенничество:',
    'alertStep1': 'Выключите интернет на компьютере (выдерните кабель).',
    'alertStep2Prefix': 'Позвоните в Банк по номеру:',
  },
  'interbankAttention': {
    'title': 'Внимание!',
    'intro': 'При формировании налоговых платежей убедитесь, что:',
    'item1': 'РМА плательщика и получателя указаны верно;',
    'item2': 'Коды платежей соответствуют назначению;',
    'item3': 'Заполнены все обязательные поля (включая классификацию доходов).',
    'footer': 'Ошибки могут привести к отклонению платежа или неправильному зачислению налогов.',
  },
};

export default translations;
